import Request from './request';
import consts from "@/consts.js";
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

async function fetch(data) {
    return Request('get', "api/supplier-materials", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return fetch(data);
}

async function fetchBySupplier(data) {
    if (!data) data = {};
    return Request('post', "api/supplier-materials/",Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

async function getSupplierMaterials(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    // data.fieldFilter = ["name",]; //仅筛选少许必要字段
    return Request('post', "api/supplier-materials/", data);
}

async function batchSave(data) {
    return Request('post', "api/supplier-materials/batch-save", data);
}

async function releasePrice(data) {
    return Request('post', "api/supplier-materials/release-to-topmall", data);
}

async function fetchProduct(data) {
    return Request('get', "api/purchases/get-add-item-info", data);
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/supplier-materials/" + id);
}

// api/supplier-materials/get-relation-ship
async function fetchRelation(data){
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/supplier-materials/get-relation-ship", data);
}

async function judgeOnlySupplierMaterial() {
    return Request('get', "api/supplier-materials/judge-only-supplier-material");
}

// 导出当前库存报表
async function noOnlySupplierMaterialExport() {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/supplier-materials/no-only-supplier-material-export')
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
  }
async function batchAddImports(id,file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    data.append("supplier_id", id);
    return Request('post', "api/supplier-materials/add-materials-import", data);
}
  
async function batchModifyImports(id,file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    data.append("supplier_id", id);
    return Request('post', "api/supplier-materials/modify-material-price-import", data);
}
  
async function TemplateExport(id) {
    // 导入模板下载
    store.dispatch('fullscreenLoading')
    const response = await Request('get', "api/supplier-materials/modify-price-export?supplier_id="+id)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function syncAccountMaterials(id) {
    return Request('get', "api/supplier-materials/sync-account-materials/" + id);
}

async function syncAndAddAccountMaterials(id) {
    return Request('get', "api/supplier-materials/sync-and-add-account-materials/" + id);
}

async function fetchIntelligentProduct(data) {
    return Request('get', "api/purchases/get-add-item-info", data, false, false, true);
}

export default {
    fetch,
    fetchAll,
    fetchOne,
    getSupplierMaterials,
    batchSave,
    releasePrice,
    fetchBySupplier,
    fetchProduct,
    fetchRelation,
    judgeOnlySupplierMaterial,
    noOnlySupplierMaterialExport,
    batchAddImports,
    batchModifyImports,
    TemplateExport,
    syncAccountMaterials,
    syncAndAddAccountMaterials,
    fetchIntelligentProduct,
};